import { get } from 'lodash';

const initialState = {
  isFetching: false,
  hasFetched: false,
  data: [],
  fetchError: null
};

export default function spaceTags (state = initialState, action) {
  const { data, fetchError, type } = action;

  if ('SPACE_TAGS_CLEAR_STORE' === type) {
    return { ...initialState };
  }

  if ('SPACE_TAGS_FETCH_REQUEST' === type) {
    return { ...state, isFetching: true };
  }

  if ('SPACE_TAGS_FETCH_SUCCESS' === type) {
    return { ...state, data: get(data, 'space_type.values'), hasFetched: true, isFetching: false };
  }

  if ('SPACE_TAGS_FETCH_FAILURE' === type) {
    return { ...state, fetchError, hasFetched: true, isFetching: false };
  }

  return state;
}
